import { NumericFormat, NumericFormatProps } from 'react-number-format';
import React from "react";

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

export const NumericFormatCustomMoney = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustomMoneyNoDecimal(props, ref) {
        const { onChange, ...other } = props;

        return (
           <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                allowLeadingZeros
                thousandSeparator={'.'}
                decimalSeparator={','}
                valueIsNumericString
                prefix="R$ "
                decimalScale={2}
                fixedDecimalScale
            />
        );
    },
);

export const NumericFormatCustomMoneyNoDecimal = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustomMoneyNoDecimal(props, ref) {
        const { onChange, ...other } = props;

        return (
           <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                allowLeadingZeros
                thousandSeparator={'.'}
                decimalSeparator={','}
                valueIsNumericString
                prefix="R$ "
                decimalScale={0}
                fixedDecimalScale
            />
        );
    },
);
